import React from "react";
import PlayerAssetAddEditPage from "./PlayerAssetAddEditPage";
import { PLAYER_ASSET_TYPES } from "../../../constants/playerAssetTypes";

const PlayerAvatarAddEditPage = () => <PlayerAssetAddEditPage config={PLAYER_ASSET_TYPES.avatar} />;

export default PlayerAvatarAddEditPage;
